import { Typography } from 'antd';
import { FC } from 'react';
import './index.css';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';

const { Title } = Typography;

// type TextHeadingProps = {
//   label: string;
//   name: string;
//   outCome?: { error: string };
//   size?: 'large' | 'middle' | 'small' | undefined;
//   description?: object;
//   indexKey: number;
//   // allInputOnchageHandler: (name: string, fieldValue: string, sysid?: string) => void;
// };

const TextHeading = ({
  label,
  name,
  size = 'large',
  description,
  indexKey,
}) => {
  //TO RENDER DESCRIPTION OF INPUTS
  function ShowDescription(description) {
    return <InputDescription description={description} />;
  }

  return (
    <>
      <div className="text-heading-container">
        <Title level={4}>{description && ShowDescription(description)}</Title>
      </div>
    </>
  );
};

export default TextHeading;
